export class Locale {
  code: string;
  name: string;
}


// WEBPACK FOOTER //
// ./libs/atenea-cms/src/core/models/locale.model.ts